import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Alert } from 'reactstrap';
import DefaultProduct from './DefaultProduct';

import { loadStoreDetails, updateStoreDetails, updateStorePicture } from '../../../actions/settings'
import { mockStoreDetails, mockStoreTypes } from '../../../model/mockStoreDetails';
import { IMAGE_PRESETS, processImageFileInput, revokeImagePreviewUrl } from '../../../utils/imageUtils';
import { toast } from 'react-toastify';

import s from './StoreSettings.module.scss';
import TimePicker from '../../../components/TimePicker';
import { withTranslation } from '../../../i18n/LanguageContext';

function normalizeTipPayoutRoutingMode(value) {
    const parsed = Number(value);
    return parsed === 1 || parsed === 2 || parsed === 3 ? parsed : 3;
}

function normalizeStoreDetails(storeDetails) {
    return {
        ...storeDetails,
        TipPayoutRoutingMode: normalizeTipPayoutRoutingMode(storeDetails?.TipPayoutRoutingMode)
    };
}

class StoreSettings extends React.Component {
    
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
    };

    state = {
        popovers: {},
        promoAlert: false,
        isAddModal: false,
        curStoreDetails: mockStoreDetails,
        picFile: null,
        tempPicture: "",
        storeError: "",
        pictureError: ""
    };

    constructor() {
        super();
        
        this.changeStoreName = this.changeStoreName.bind(this);
        this.changeStoreType = this.changeStoreType.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.changeTelephone = this.changeTelephone.bind(this);
        this.changeUseClientAddress = this.changeUseClientAddress.bind(this);
        this.changeStreet = this.changeStreet.bind(this);
        this.changeCity = this.changeCity.bind(this);
        this.changeState = this.changeState.bind(this);
        this.changeZipcode = this.changeZipcode.bind(this);
        this.changeDescription = this.changeDescription.bind(this);
        this.changeReceiptText = this.changeReceiptText.bind(this);
        //this.changePicture = this.changePicture.bind(this);
        this.changeStoreImage = this.changeStoreImage.bind(this);
        this.onChangeStartTime = this.onChangeStartTime.bind(this);
        this.onChangeEndTime = this.onChangeEndTime.bind(this);
        this.changeTipPayoutRoutingMode = this.changeTipPayoutRoutingMode.bind(this);
    }

    componentDidMount() {
        console.log("setting mouted")
        this.props.dispatch(loadStoreDetails());
    }

    componentDidUpdate(prevProps) {
        if (this.props.storeDetails !== prevProps.storeDetails) {
            this.setState({ curStoreDetails: normalizeStoreDetails(this.props.storeDetails) });
        } else if (this.props.isReceiving !== prevProps.isReceiving && this.props.isReceiving == false) {
            this.setState({ curStoreDetails: normalizeStoreDetails(this.props.storeDetails) });
        }
    }

    changeStoreName(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.StoreName = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeStoreType(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.StoreType = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeEmail(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.Email = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeTelephone(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.Telephone = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeUseClientAddress(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.UseClientAddress = event.target.checked;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeStreet(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.Street = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeCity(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.City = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeState(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.State = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }
    
    changeZipcode(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.Zipcode = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeDescription(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.Description = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeReceiptText(event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.ReceiptText = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    async changeStoreImage(event) {
        const input = event.target;
        const file = input.files && input.files[0];

        if (!file) {
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "", pictureError: "" });
            return;
        }

        try {
            const result = await processImageFileInput(
                file,
                this.state.tempPicture,
                IMAGE_PRESETS.product
            );
            this.setState({
                tempPicture: result.previewUrl,
                picFile: result.file,
                pictureError: "",
            });
        } catch (error) {
            console.error('[StoreSettings] changeStoreImage failed', error);
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ picFile: null, tempPicture: "", pictureError: "" });
            toast.error(error.message || 'Could not use that photo. Try again with a smaller image.');
        } finally {
            input.value = '';
        }
    }

    onChangeStartTime (event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.AutoStartWP = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    onChangeEndTime (event) {
        var curStoreDetails = this.state.curStoreDetails;
        curStoreDetails.AutoCloseWP = event.target.value;
        this.setState({ curStoreDetails: curStoreDetails, storeError: "" });
    }

    changeTipPayoutRoutingMode(event) {
        const nextMode = normalizeTipPayoutRoutingMode(event.target.value);
        this.setState(({ curStoreDetails }) => ({
            curStoreDetails: {
                ...curStoreDetails,
                TipPayoutRoutingMode: nextMode
            },
            storeError: ""
        }));
    }

    // changeStoreImage(event) {
    //     var curStoreDetails = this.state.curStoreDetails;
    //     curStoreDetails.StoreImage = event.target.value;
    //     this.setState({ curStoreDetails: curStoreDetails });
    // }

    onClickSaveStoreDetails = (e) => {
        e.preventDefault();

        var storeError = "";
        const curStoreDetails = normalizeStoreDetails(this.state.curStoreDetails);

        if (curStoreDetails.StoreName == "") {
            storeError = "Please input store name";
        } else if (curStoreDetails.Email == "") {
            storeError = "Please input email";
        } else if (curStoreDetails.Telephone == "") {
            storeError = "Please input phone number";
        } else if (curStoreDetails.Street == "") {
            storeError = "Please input street";
        } else if (curStoreDetails.City == "") {
            storeError = "Please input street";
        } else if (curStoreDetails.Zipcode == "") {
            storeError = "Please input zip code";
        }

        if (storeError == "") {
            this.props.dispatch(updateStoreDetails(curStoreDetails))
        }
        this.setState({storeError: storeError});
    }

    onClickSavePicture = (e) => {
        e.preventDefault();

        var pictureError = "";
        const {picFile} = this.state;
        
        if (picFile == null) {
            pictureError = "Please choose an image";
        } 

        if (pictureError == "") {
            this.props.dispatch(updateStorePicture(picFile))
        }
        this.setState({pictureError: pictureError});
    }

    

    render() {

        const { tempPicture, storeError, pictureError } = this.state;
        const curStoreDetails = normalizeStoreDetails(this.state.curStoreDetails);
        const tipPayoutRoutingMode = normalizeTipPayoutRoutingMode(curStoreDetails.TipPayoutRoutingMode);
        const { states, t } = this.props;

        return (
            <div className="row no-gutters store-settings">
                <div className="col">
                    <div className="bg-second p-4 ">
                        <form>
                            <div className={`${s.header}`}>
                                <h3 className="mt-0 mb-5 text-white">{t('store.details')}</h3>
                                <div className="row">
                                    <div className="col-md-6">
                                        <TimePicker label={t('store.wpStart')} value={curStoreDetails.AutoStartWP} onChange={this.onChangeStartTime} />
                                    </div>
                                    <div className="col-md-6">
                                        <TimePicker label={t('store.wpEnd')} value={curStoreDetails.AutoCloseWP} onChange={this.onChangeEndTime} />
                                        <small className="form-text text-muted">
                                            {t('store.wpEndHelp')}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{t('store.name')}</label>
                                        <input type="text" className="form-control" placeholder="" required="" value={curStoreDetails.StoreName} onChange={this.changeStoreName}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{t('store.type')}</label>
                                        <select className={`form-control ${s.select}`} value={curStoreDetails.StoreType} onChange={this.changeStoreType}>
                                        {mockStoreTypes.map((storeType, i) => 
                                            <option value={storeType.Id} key={storeType.Id}>{storeType.Name}</option>
                                        )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{t('store.email')}</label>
                                        <input type="text" className="form-control" placeholder="info@rebelity.com" required="" value={curStoreDetails.Email} onChange={this.changeEmail}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{t('store.phone')}</label>
                                        <input type="text" className="form-control" placeholder="" required="" value={curStoreDetails.Telephone} onChange={this.changeTelephone}/>
                                    </div>
                                </div>
                            </div>
                            <div className={`d-flex align-items-center px-4 mb-3 text-white py-2 mt-4 ${s.address}`}>
                                <b>{t('store.address')} </b> <i className={`${s.description}`}> ( {t('store.useAccountDefault')} ) </i>
                                <label className="switch ml-auto my-1">
                                    <input type="checkbox" checked={curStoreDetails.UseClientAddress} onChange={this.changeUseClientAddress}/>
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="form-group">
                                        <label>{t('store.street')}</label>
                                        <input type="text" className="form-control" placeholder="1234 Lets Party Dr" required="" value={curStoreDetails.Street} onChange={this.changeStreet}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>{t('store.city')}</label>
                                        <input type="text" className="form-control" placeholder="Atlanta" required="" value={curStoreDetails.City} onChange={this.changeCity}/>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>{t('store.state')}</label>
                                        <select className={`form-control ${s.select}`} value={curStoreDetails.State} onChange={this.changeState}>
                                        {states.map((st, i) => 
                                            <option value={st.value} key={st.value}>{st.text}</option>
                                        )}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>{t('store.zip')}</label>
                                        <input type="text" className="form-control" placeholder="30316" required="" value={curStoreDetails.Zipcode} onChange={this.changeZipcode}/>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group col-md-12">
                                <label>{t('store.description')}</label>
                                <textarea className={`form-control mb-2 ${s.text_area}`} placeholder={t('store.descriptionPlaceholder')} value={curStoreDetails.Description == null ? "" : curStoreDetails.Description} onChange={this.changeDescription}></textarea>
                            </div>
                            <div className="form-group col-md-12">
                                <label>{t('store.receiptFooter')}  <i className={`${s.description}`}> ( {t('store.receiptFooterHelp')} ) </i></label>
                                <textarea className={`form-control mb-2 ${s.text_area}`} placeholder="Thank you for your Patronage!" value={curStoreDetails.ReceiptText == null ? "" : curStoreDetails.ReceiptText} onChange={this.changeReceiptText}></textarea>
                            </div>
                            <div className={`d-flex align-items-center px-4 mb-3 text-white py-2 mt-4 ${s.address}`}>
                                <div>
                                    <b>{t('store.tipPayoutRouting')}</b>
                                    <i className={`${s.description} ml-2`}>
                                        {tipPayoutRoutingMode === 2
                                            ? t('store.tipModeMerchant')
                                            : tipPayoutRoutingMode === 3
                                                ? t('store.tipModeDisabled')
                                                : t('store.tipModePlatform')}
                                    </i>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>{t('store.tipRoutingMode')}</label>
                                        <select className={`form-control ${s.select}`} value={tipPayoutRoutingMode} onChange={this.changeTipPayoutRoutingMode}>
                                            <option value={1}>{t('store.optionPlatform')}</option>
                                            <option value={2}>{t('store.optionMerchant')}</option>
                                            <option value={3}>{t('store.optionDisable')}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row alert-container">
                            {
                                storeError && (
                                    <Alert className="alert-sm" color="danger">
                                        {storeError}
                                    </Alert>
                                )
                            }
                            </div>
                            <button type="submit" className="btn pt-2 btn-block" onClick={(e) => this.onClickSaveStoreDetails(e)}>{t('store.saveDetails')}</button>
                        </form>
                    </div>
                </div>
                <div  className={`col-md-4 ${s.image_container}`}>
                    <div>
                        <h3 className="mt-0 text-white">{t('store.image')} </h3>
                        <p><i className={`${s.description}`}> ({t('store.imageDefault')}) </i></p>
                        <form>
                            <div className="d-flex justify-content-center my-4">
                                <div className="image-upload-compact">
                                    <input id="store-img" type="file" onChange={this.changeStoreImage} accept="image/*" />
                                    <label htmlFor="store-img" className="image-upload-label">
                                        {(tempPicture || curStoreDetails.StoreImage) ? (
                                            <>
                                                <img
                                                    src={tempPicture || curStoreDetails.StoreImage}
                                                    alt={t('store.storeAlt')}
                                                    className="image-upload-preview"
                                                />
                                                <div className="image-upload-overlay">
                                                    <i className="zmdi zmdi-camera"></i>
                                                    <span>{t('store.change')}</span>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="image-upload-placeholder">
                                                <i className="zmdi zmdi-image-alt"></i>
                                                <span>{t('store.addImage')}</span>
                                            </div>
                                        )}
                                    </label>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="row alert-container">
                    {
                        pictureError && (
                            <Alert className="alert-sm" color="danger">
                                {pictureError}
                            </Alert>
                        )
                    }
                    </div>
                    <button type="submit" className="btn pt-2 btn-block" onClick={(e) => this.onClickSavePicture(e)}>{t('store.saveImage')}</button>

                    <DefaultProduct />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        merchant: state.auth.merchant,
        storeDetails: state.settings.storeDetails,
        states: state.settings.states,
        isReceiving: state.settings.isReceiving,
        isUpdating: state.settings.isUpdating,
        isDeleting: state.settings.isDeleting,
        idToDelete: state.settings.idToDelete,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(StoreSettings)));

